import { render, staticRenderFns } from "./BounceParcelWaitingOut.vue?vue&type=template&id=1dd9620a&scoped=true"
import script from "./BounceParcelWaitingOut.vue?vue&type=script&lang=js"
export * from "./BounceParcelWaitingOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd9620a",
  null
  
)

export default component.exports